export default "__VITE_ASSET__1680ead0__"